import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';
import { getDisplayDateAndTime } from 'utils/date';

import type { ClientApprovalNoteV2 } from 'types';

import './client-approval-entry-note.scss';

applyTranslations(require('./client-approval-entry-note.i18n.json'));

type Props = {
  note: ClientApprovalNoteV2
};

const ClientApprovalEntryNote = ({ note }: Props): JSX.Element => {
  const { author, date, isDeleted, isEdited } = note;
  const editedSuffix = (isEdited && !isDeleted) ? __t('deliverable_approval_note.edited_marker') : '';
  const deletedSuffix = isDeleted ? __t('deliverable_approval_note.deleted_marker') : '';
  const nameFallback = (note.author.type === 'external_client')
    ? __t('client_approval_entry_note.client_name_fallback')
    : __t('client_approval_entry_note.account_manager_name_fallback');

  return (
    <div className="client-approval-entry-note">
      <div className="client-approval-entry-note__details">
        {`${deletedSuffix}${getDisplayDateAndTime(date)} | ${author.name ?? nameFallback} ${editedSuffix}`}
      </div>
      {
        !isDeleted && <div className="client-approval-entry-note__message">{note.text}</div>
      }
    </div>
  );
};

export default ClientApprovalEntryNote;
